import { Component, ElementRef, ViewChild } from '@angular/core';
import { UserService } from '@projects/admin/src/app/services/user.service';

@Component({
  selector: 'app-update-team-structure-modal',
  templateUrl: './update-team-structure-modal.component.html',
  styleUrls: ['./update-team-structure-modal.component.scss'],
})
export class UpdateTeamStructureModalComponent {
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;

  isDragging = false;
  activeFilterTab: 'all' | 'valid' | 'error' = 'all';

  constructor(public userService: UserService) {}

  closeModal() {
    this.userService.closeTeamStructureModal();
    this.activeFilterTab = 'all';
    this.isDragging = false;
  }

  triggerFileInput() {
    if (this.fileInputRef && this.fileInputRef.nativeElement) {
      this.fileInputRef.nativeElement.value = '';
      this.fileInputRef.nativeElement.click();
    }
  }

  onFileSelected(event: any) {
    const file = event?.target?.files?.[0];
    if (file) {
      this.userService.stageTeamStructureCsvFile(file);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    const file = event?.dataTransfer?.files?.[0];
    if (file) {
      this.userService.stageTeamStructureCsvFile(file);
    }
  }

  removeStagedFile() {
    this.userService.removeTeamStructureStagedFile();
    if (this.fileInputRef && this.fileInputRef.nativeElement) {
      this.fileInputRef.nativeElement.value = '';
    }
  }

  downloadSample() {
    this.userService.downloadTeamStructureSampleCsv();
  }

  onValidate() {
    this.activeFilterTab = 'all';
    this.userService.validateUploadedTeamStructureCsv();
  }

  setFilterTab(tab: 'all' | 'valid' | 'error') {
    this.activeFilterTab = tab;
  }

  get filteredRows() {
    const rows = this.userService.teamStructureModal.rows || [];
    if (this.activeFilterTab === 'valid') {
      return rows.filter((r) => r.status === 'valid');
    }
    if (this.activeFilterTab === 'error') {
      return rows.filter((r) => r.status === 'error');
    }
    return rows;
  }

  onSkipToggle(checked: boolean) {
    this.userService.teamStructureModal.skipErrors = checked;
  }

  exportErrors() {
    this.userService.exportTeamStructureErrorsCsv();
  }

  goToStep1() {
    this.userService.teamStructureModal.step = 1;
  }

  applyUpdates() {
    this.userService.executeTeamStructureUpdate();
  }
}

